import { valueOutOfRange } from 'src/helpers/utilities';
import { buildLnmActionJob } from './local_action_lnm_helpers';
//Types
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

export const saveLocalAction = (
	controlOption: LocalControlOptions,
	method: string,
	transitionDuration?: {
		min: number;
		max: number;
		showError: boolean;
		disabled: boolean;
	},
): ActionJob => {
	if (!controlOption) return null;

	const lnmAction = buildLnmActionJob(controlOption);
	if (lnmAction) return lnmAction;

	let actionMethod = method;
	let actionControlOption = controlOption;

	if (controlOption.virtual) {
		actionMethod = controlOption.virtual.selected.value.split(':')[0];
		actionControlOption = controlOption.virtual.selected;
	}

	const saveAction: ActionJob = {
		method: actionMethod,
		params: { id: actionControlOption.params.id },
	};

	if (actionMethod !== 'switch.toggle') {
		if (actionControlOption.onOffState?.checked) {
			saveAction.params.on = actionControlOption.params.on;
		}

		for (const attr in actionControlOption.attr) {
			const param = actionControlOption.params[attr];
			if (actionControlOption.attr[attr] && param != null && param !== '') {
				if (/^(toggle_after|transition_duration)$/.test(attr)) {
					if (
						attr == 'toggle_after' &&
						actionControlOption.onOffState?.selectBox &&
						!actionControlOption.onOffState.checked
					) {
						continue;
					}
					if (attr == 'transition_duration') {
						transitionDuration.showError = valueOutOfRange(
							param,
							transitionDuration.min,
							transitionDuration.max,
						);
						if (transitionDuration.showError) {
							return null;
						}
					}
					saveAction.params[attr] = Number(param);
				} else if (attr === 'config' && typeof actionControlOption.attr?.config === 'object') {
					const configParam = actionControlOption.attr.config || {};
					if (configParam.ambient) {
						saveAction.params.config = { ambient: {} };
						for (const item in configParam.ambient) {
							if (configParam.ambient[item]) {
								saveAction.params.config.ambient[item] =
									actionControlOption.params.config.ambient[item];
							}
						}
					} else {
						saveAction.params.config = {};
						for (const item in configParam) {
							if (configParam[item]) {
								saveAction.params.config[item] = actionControlOption.params.config[item];
							}
						}
					}
				} else {
					saveAction.params[attr] = param;
				}
			}
		}
	}

	return saveAction;
};
